export const Divider = {
  baseStyle: {
    my: "blockMargin",
    color: "gray.50",
  },
};
